var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalLinkImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 14,
    viewBox: "0 0 33 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.451 1H31.051C31.5737 1 32.0751 1.20766 32.4447 1.57729C32.8143 1.94693 33.022 2.44826 33.022 2.971V11.645C33.0221 11.9039 32.9712 12.1603 32.8723 12.3996C32.7733 12.6388 32.6281 12.8562 32.4451 13.0394C32.262 13.2225 32.0447 13.3678 31.8055 13.4669C31.5663 13.566 31.3099 13.617 31.051 13.617H3.451C2.92826 13.617 2.42693 13.4093 2.05729 13.0397C1.68766 12.6701 1.48 12.1687 1.48 11.646V8.846L0 7.364L1.48 5.769V2.969C1.48053 2.4466 1.68842 1.94579 2.058 1.57659C2.42758 1.20738 2.9286 1 3.451 1V1Z",
    fill: "#005CB0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.89 6.106H5.835C5.82357 5.97453 5.84075 5.84215 5.88535 5.71795C5.92996 5.59375 6.00092 5.48068 6.09338 5.38652C6.18583 5.29236 6.29758 5.21933 6.42094 5.17246C6.5443 5.12559 6.67634 5.10599 6.808 5.115C6.92634 5.09933 7.04666 5.10934 7.16078 5.14434C7.2749 5.17935 7.38014 5.23853 7.46934 5.31786C7.55854 5.39719 7.6296 5.4948 7.67768 5.60406C7.72577 5.71331 7.74975 5.83164 7.748 5.951C7.748 6.406 7.48 6.615 7.057 6.932C6.80377 7.07324 6.5928 7.27948 6.44584 7.52944C6.29889 7.7794 6.22127 8.06404 6.221 8.354L6.226 8.685H7.161V8.431C7.161 7.917 7.361 7.767 7.884 7.367C8.14659 7.21935 8.36653 7.00631 8.52248 6.74856C8.67842 6.49081 8.76507 6.19712 8.774 5.896C8.774 4.815 7.861 4.296 6.861 4.296C6.60807 4.26424 6.35126 4.288 6.10845 4.36561C5.86564 4.44323 5.64266 4.57283 5.45505 4.74541C5.26744 4.91798 5.11969 5.12938 5.02211 5.36487C4.92452 5.60037 4.87944 5.85431 4.89 6.109V6.106ZM6.008 10.054C5.99611 10.2011 6.02898 10.3484 6.1023 10.4765C6.17562 10.6047 6.28597 10.7076 6.41885 10.7719C6.55173 10.8362 6.70095 10.8588 6.84691 10.8368C6.99287 10.8147 7.12875 10.7491 7.23673 10.6484C7.34471 10.5478 7.41974 10.4168 7.45196 10.2728C7.48419 10.1287 7.47211 9.97828 7.41731 9.84121C7.36251 9.70414 7.26755 9.58685 7.14489 9.50472C7.02223 9.42259 6.87761 9.37946 6.73 9.381C6.6377 9.37441 6.54504 9.3869 6.45778 9.41768C6.37052 9.44846 6.29053 9.49688 6.2228 9.55992C6.15507 9.62296 6.10104 9.69928 6.06409 9.78411C6.02713 9.86894 6.00804 9.96047 6.008 10.053V10.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.128 8.926C17.9095 8.926 18.543 8.29248 18.543 7.511C18.543 6.72952 17.9095 6.096 17.128 6.096C16.3465 6.096 15.713 6.72952 15.713 7.511C15.713 8.29248 16.3465 8.926 17.128 8.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79 8.926C23.5715 8.926 24.205 8.29248 24.205 7.511C24.205 6.72952 23.5715 6.096 22.79 6.096C22.0085 6.096 21.375 6.72952 21.375 7.511C21.375 8.29248 22.0085 8.926 22.79 8.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.885 8.926C28.6665 8.926 29.3 8.29248 29.3 7.511C29.3 6.72952 28.6665 6.096 27.885 6.096C27.1035 6.096 26.47 6.72952 26.47 7.511C26.47 8.29248 27.1035 8.926 27.885 8.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.127 1.986V11.843",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_11",
    x: -6,
    y: -2,
    width: 45.022,
    height: 24.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_11",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLinkImg);
export default __webpack_public_path__ + "static/media/modal-link-img.abf5483284d37954634f04a8a45ffa09.svg";
export { ForwardRef as ReactComponent };